import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actionCreators from "../actions/auth";
import { bindActionCreators } from "redux";

const SessionTimer = (props) => {
  useEffect(() => {
    if (props.auth.timerRunning) {
      let lastUpdateTime = Date.now();
      const interval = setInterval(() => {
        const now = Date.now();
        const deltaTime = now - lastUpdateTime;
        lastUpdateTime = now;
        props.updateTimer(deltaTime);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      return null;
    }
  }, [props.auth.timerRunning]);

  return <div>{props.children}</div>;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

const mapStateToProps = ({ auth }, props) => ({
  auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimer);



// WEBPACK FOOTER //
// ./src/providers/sessionTimer.js